import Cookies from 'js-cookie'

const TokenKey = 'admin-doctor-token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return sessionStorage.getItem(TokenKey)
  //return ReadCookieMap()
}

export function setToken(token,express) {
  // return Cookies.set(TokenKey, token, express)
  return sessionStorage.setItem(TokenKey, token)
  //return window.WriteCookie(TokenKey,token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
  //return Cookies.remove(TokenKey)
  //window.WriteCookie(TokenKey,"#")
}
/*
function ReadCookieMap(){
  let result = window.ReadCookie(TokenKey).replace(/[\r\n]/g,"");  //取得浏览器版本号
  let state=result.substr(0,1);            //状态，0-错误，1-正雀，2-错误
  if(state==1){
    if(result.substr(2)==''){
      return undefined;
    }else{
      return result.substr(2);
    }
  }
  return undefined;
}
*/



// WEBPACK FOOTER //
// ./src/utils/auth.js